
define('TavanoTeam.DoubleUnitSales.Confirmation.View',
[
    'tavanoteam_confirmation_request.tpl',
    'underscore',
    'Backbone'
],
function (tavanoteam_confirmation_request,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: tavanoteam_confirmation_request,

        initialize: function (options) {		
		},
         getContext: function () {
            return{
                isConfirmation: this.options.isConfirmation
            }
        }

    })
})
